export class MoleculePanelServiceInfoWebspaceComponent {
    public template = require('./panel-service-info-webspace.html');
}
